import React from "react";
import IconButton from "@material-ui/core/IconButton";
import HamburgerIcon from "@material-ui/icons/Menu";
import Menu from "../menu/Menu";
import { makeStyles } from "@material-ui/core/styles";
import { useMenu } from "./MenuContext";
import { colors } from "../../theme";

const useStyles = makeStyles((theme) => ({
  hamburger: {
    color: colors.LINK,
    width: "60px",
    height: "42px",
    "&:hover":{ 
      color:  colors.LINK_HOVER
    }
  },
}));

export default function MenuContainer() {
  const classes = useStyles();
  const { openMenu } = useMenu();

  return (
    <>
      <IconButton onClick={openMenu} style={{ backgroundColor: 'transparent' }}>
        <HamburgerIcon className={classes.hamburger} />
      </IconButton>

      <Menu />
    </>
  );
}
